import { UpdateFrequency } from '../generated/graphql';

// Rough cross-model token estimate (chars/4) — matches the worker's chars/4 fallback and
// is close enough for a creation-time estimate of the monitored agent's generation cost.
export const estTokens = (text: string | null | undefined): number =>
  Math.ceil((text?.length ?? 0) / 4);

// Typical length of a "sketch" plan completion, used to estimate output tokens before any
// plan has actually been generated.
const SKETCH_COMPLETION_TOKENS = 800;

// Estimated agent tokens for ONE check-in: per task, the (frozen) prompt + a sketch reply.
export const estimateRunTokens = (taskPrompts: string[]): number =>
  taskPrompts.reduce((sum, p) => sum + estTokens(p) + SKETCH_COMPLETION_TOKENS, 0);

// Auto-update runs per ~30-day month for a given frequency (0 = manual / no auto-update).
export const runsPerMonth = (
  frequency: UpdateFrequency | null | undefined,
  customHours?: number | null,
): number => {
  switch (frequency) {
    case UpdateFrequency.ThirtyMinutes:
      return 30 * 24 * 2;
    case UpdateFrequency.Hourly:
      return 30 * 24;
    case UpdateFrequency.SixHours:
      return 30 * 4;
    case UpdateFrequency.Daily:
      return 30;
    case UpdateFrequency.Weekly:
      return Math.round((30 / 7) * 10) / 10;
    case UpdateFrequency.Custom:
      return customHours && customHours > 0 ? Math.round((720 / customHours) * 10) / 10 : 0;
    default:
      return 0; // MANUAL / none
  }
};

export const humanizeTokens = (n: number): string => {
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `${Math.round(n / 1_000)}k`;
  return String(Math.round(n));
};
